<!--
Component <base-search-box> element

Generic container to render cards

@example

  <base-card>
    <template v-slot:header>
      <some-custom-header />
    </template>

    <div class="m-card-layout-main">
      Main Content
    </div>

    <template v-slot:footer>
      <some-custom-footer />
    </template>

  </base-card>

-->

<template lang="html">
  <section class="m-card">
    <header v-if="hasHeader()"><slot name="header">Header</slot></header>
    <main><slot>Main</slot></main>
    <footer v-if="hasFooter()"><slot name="footer">Footer</slot></footer>
  </section>
</template>

<script lang="js">
  export default  {
    name: "base-card",
    methods: {
      hasHeader() {
        return !!this.$slots.header;
      },
      hasFooter() {
        return !!this.$slots.footer;
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  @include drag-drop-a-tag;
  .m-card {
    box-sizing: border-box;
    font-size: 0.8125rem;
    display: flex;
    flex-direction: column;
    header,
    main,
    footer {
      box-sizing: border-box;
    }
    flex: 1;
  }
  main {
    display: flex;
    flex: 1;
  }
</style>
